module.exports = __webpack_public_path__ + "static/media/interrogacion.0ee5019e.png";